import { Div2Floor } from "../utils/Div2Floor";
import {
  enumButtonLabelPosition,
  enumElementDrawStates,
  kfontIconNameRegularThicc,
  kOCNDarkGrayColor
} from "../constants";
import { QXIconButton } from "./QXIconButton";
import { Globals } from "./Globals";
import { SetCtxFont } from "../utils/SetCtxFont.js";

export class QLargeSVGIconButton extends QXIconButton {
  constructor() {
    super();
    this.fFontString = null;
    this.fBorderThickness = 0;
    this.fFillColor = kOCNDarkGrayColor;
  }

  DrawLabel(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var txtFillStyle;

    switch (this.GetDrawState()) {
      case enumElementDrawStates.Std:
      case enumElementDrawStates.MouseDown:
      case enumElementDrawStates.Hover:
        txtFillStyle = Globals._themeMode.text.body;
        if (this.fTxtFillStyle != null) {
          txtFillStyle = this.fTxtFillStyle;
        }
        break;
      case enumElementDrawStates.Disabled:
        txtFillStyle = "#8D8D8D";
        break;
    }

    ctx.fillStyle = txtFillStyle;
    var fontString = "bold 14px Verdana";

    if (this.fFontString != null) {
      fontString = this.fFontString;
    }

    SetCtxFont(ctx, fontString);
    var txt = this.fLabel;
    var txtHOffset = Div2Floor(this.fWidth);
    ctx.textAlign = this.fTextAlign;
    ctx.textBaseline = "bottom";

    var xPos, yPos;
    switch (this.fLabelPosition) {
      case enumButtonLabelPosition.below:
        xPos = this.fHorzOffset + txtHOffset;
        yPos = this.fVertOffset + this.fHeight + 20;
        break;
      case enumButtonLabelPosition.center:
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + txtHOffset;
        yPos = this.fHeight / 2;
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
      case enumButtonLabelPosition.left:
        var labelW = this.MeasureLabel();
        var txtHIndent = 6;
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + labelW / 2 + txtHIndent + this.fLabelInset;
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
      case enumButtonLabelPosition.right:
        var labelW = this.MeasureLabel();
        var txtHIndent = 6;
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + this.GetWidth() - labelW - txtHIndent;
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
    }
    ctx.fillText(txt, xPos, yPos);

    if (this.fLabel2 != null) {
      yPos += 6;
      ctx.fillText(this.fLabel2, xPos, yPos);
    }
  }

  DrawFAIcon(drawBuffer) {
    var theIcon = this.fFontIconOverride;
    var fs = kfontIconNameRegularThicc;

    var ctx = drawBuffer.getContext("2d");
    ctx.save();

    ctx.fillStyle = Globals._accountInfo.GetButtonColor();

    var parent = this.GetParentElement();
    if (parent == null) parent = this;
    ctx.textBaseline = "middle";

    var xPos = Math.floor(parent.fHorzOffset + this.fIconHInset) + 6;
    var yPos = this.fVertOffset + this.fHeight / 2;
    SetCtxFont(ctx, fs);
    ctx.fillText(theIcon, xPos, yPos, parent.GetWidth());

    ctx.shadowBlur = 0;
    ctx.globalAlpha = 1;
    ctx.restore();
  }
}
